import { CometChatUIKit } from "@cometchat/chat-uikit-react";
import { saveUserDetails } from "../store/slices/common";

export async function loginUser(resData, dispatch) {
    try {
      // Handle different response structures
      const userProfile = resData.profile || resData;
      const cometChatData = resData?.cometChat || {};
      
      // Store the original userType before CometChat login
      const originalUserType = userProfile?.userType;
      
      CometChatUIKit.login(cometChatData?.uid)
        ?.then((loggedInUser) => {
          if (loggedInUser) {
            dispatch(
              saveUserDetails({
                ...userProfile,
                status: loggedInUser.status,
                ...cometChatData,
                // CRITICAL: Preserve the original userType field
                userType: originalUserType || userProfile?.userType,
              })
            );
          } else {
            // Fallback: save user details even if CometChat login fails
            dispatch(saveUserDetails({
              ...userProfile,
              userType: originalUserType || userProfile?.userType,
            }));
          }
        })
        .catch(() => {
          // Fallback: save user details even if CometChat login fails
          dispatch(saveUserDetails({
            ...userProfile,
            userType: originalUserType || userProfile?.userType,
          }));
        });
    } catch (error) {
      console.log(error);
      // Fallback: save user details even if there's an error
      const userProfile = resData.profile || resData;
      dispatch(saveUserDetails({
        ...userProfile,
        userType: userProfile?.userType,
      }));
    } finally {
      // handle comet chat login response
    }
  }
